export const getShadowRoot = (): HTMLElement | null | undefined => {
  if (typeof document !== 'undefined') {
    return document.getElementById('web3-antivirus-host')?.shadowRoot?.getElementById('web3-antivirus');
  }

  return null;
};

export const getExtensionVersion = (): string => '0.18.0';

export const getValueFromSessionChromeStorage = <TValue = Record<string, any>>(): Promise<TValue | null> => Promise.resolve(null);
export const setValueFromSessionChromeStorage = async (): Promise<void> => Promise.resolve();

export const getStorageValueAsync = <TValue = Record<string, any>>(): Promise<TValue | null> => Promise.resolve(null);
export const setStorageValueAsync = async (): Promise<void> => Promise.resolve();
